<template>
	<div class="layout-public">
		<content-container>

			<card>
				<router-view />
				<slot />
			</card>

			<public-footer />

		</content-container>
	</div>
</template>


<script>
	import PublicFooter from '@/components/public/public-footer';


	export default {
		name: 'public-layout',
		components: {
			PublicFooter
		}
	};
</script>


<style lang="scss">
@import '~@/assets/styles/references';


.layout-public {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;

    .container { min-width: 400px; max-width: 635px; flex: 0 1 auto; min-height: 0; padding: gx(1); }

    .card-body { flex-direction: row; display: flex; height: 100%; }

    .logo { display: block; margin-bottom: gx(2);
        img { width: 165px; height: 54px; }
    }

    /* Footer/Copyright
    **********************************/
    .footer { text-align: center; font-size: $font-size-xs; color: color(black, hint); padding: gx(0.5) 0; }
    .footer-line { margin-bottom: gx(0.5);
        a { color: inherit; white-space: nowrap; }
    }


    @include media-breakpoint-down(sm) {
        .container { width: auto; max-width: none; min-width: 0;}
    }
}
</style>
